import React from 'react';
import PropTypes from 'prop-types';
import { GridLoader } from 'react-spinners';
import classes from './styles.module.scss';

const Loader = ({ loading }) => {
  return (
    <div className={classes.loader_wrapper}>
      <GridLoader
        color="#2f3192d3"
        loading={loading}
        size={15}
        margin={2}
      />
    </div>
  );
};

Loader.propTypes = {
  loading: PropTypes.bool.isRequired,
};

export default Loader;